export default "__VITE_ASSET__CSusDeKu__"